import { render } from "./Special.vue?vue&type=template&id=17908c45&scoped=true"
import script from "./Special.vue?vue&type=script&lang=js"
export * from "./Special.vue?vue&type=script&lang=js"

import "./Special.vue?vue&type=style&index=0&id=17908c45&scoped=true&lang=css"

import exportComponent from "/data0/www.sxsmdx.cn/src/ui/src-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-17908c45"]])

export default __exports__